/** Minimal shape required to evaluate an enabling condition on any attribute/control. */
interface ConditionalField {
  _id: string;
  name?: string;
  friendlyName?: string;
  enablingAttribute?: string;
  enablingValue?: string;
}

/**
 * Determines whether a conditional attribute should be shown in the Summary accordion
 * based on the enabling attribute's current value in formValues.
 *
 * Works dynamically for any attribute that carries `enablingAttribute` +
 * `enablingValue` metadata from the API response (e.g. "Your High School GPA"
 * with enablingValue "First Year", or "Your Prior College GPA" with
 * enablingValue "Transfer"). Attributes without an enabling condition are
 * always shown.
 */
export function shouldShowConditionalField(
  attr: ConditionalField,
  allEntityAttributes: Record<string, ConditionalField[]>,
  formValues: Record<string, any>,
): boolean {
  // No enabling condition — always show
  if (!attr.enablingAttribute || !attr.enablingValue) return true;

  let currentEnablingValue = "";
  for (const attrs of Object.values(allEntityAttributes)) {
    if (Array.isArray(attrs)) {
      const enAttr = attrs.find(
        (a) =>
          a.name === attr.enablingAttribute ||
          a.friendlyName === attr.enablingAttribute,
      );
      if (enAttr) {
        currentEnablingValue = String(formValues[enAttr._id] ?? "").trim();
        break;
      }
    }
  }

  return currentEnablingValue === String(attr.enablingValue).trim();
}
